import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import Navbar from "./components/navbar";
import Verify from "./components/verify";
import Dashboard from "./screens/dashboard";
import DashboardLayout from "./layouts/DashboardLayout";

import Login from "./screens/login";
import Signup from "./screens/signup/containerSignup";
import LandingPage from "./screens/LandingPage";
import ResetPassword from "./screens/ResetPassword";
import ForgotPassword from "./screens/forgotPassword";

import DashBoardRouter from "./routers/DashBoardRouter";
import { useSelector } from "react-redux";
import { selectAuthStatus } from "./features/auth/authSlice";
import { CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import RouteChangeReporter from "./features/analytics/RouteChangeReporter";

function App() {
  const authStatus = useSelector(selectAuthStatus); //values: checking - authenticated - unauthenticated - failed
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  console.log('authStatus', authStatus);

  if(authStatus === 'checking'){
    return <>
      <h1 style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh'}}>
        <CircularProgress size={75}/>
      </h1>
    </>
  }

  return (
    <Router>
      <RouteChangeReporter />
      <Switch>
        <Route exact path="/">
          <Navbar handleShow={handleShow} />
          <LandingPage show={show} handleShow={handleShow} handleClose={handleClose} />
        </Route>
        <Route path="/login">
          <Navbar handleShow={handleShow} />
          <Login />
        </Route>
        <Route path="/signup">
          <Navbar handleShow={handleShow} />
          <Signup show={show} handleShow={handleShow} handleClose={handleClose} />
        </Route>
        <Route path="/verify_account/:token">
          <Navbar handleShow={handleShow} />
          <Verify show={show} handleShow={handleShow} handleClose={handleClose} />
        </Route>
        <Route path="/reset-password/:token">
          <Navbar handleShow={handleShow} />
          <ResetPassword show={show} handleShow={handleShow} handleClose={handleClose} />
        </Route>
        <Route path="/forgot-password">
          <Navbar handleShow={handleShow} />
          <ForgotPassword show={show} handleShow={handleShow} handleClose={handleClose} />
        </Route>
        <Route path="/dashboard">
          {authStatus === "authenticated" ? (
            <DashboardLayout>
              <Dashboard />
              <DashBoardRouter />
            </DashboardLayout>
          ) : (
            <Redirect to="/" />
          )}
        </Route>
      </Switch>
    </Router>
  );
}

export default App;